module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "l-container",
    attrs: {
      "id": "app"
    }
  }, [_c('GlobalHeader', {
    attrs: {
      "current-section": _vm.currentSection
    },
    on: {
      "currentUpdate": _vm.handleCurrentUpdate
    }
  }), _c('main', {
    staticClass: "l-content"
  }, [_c('router-view', {
    attrs: {
      "currentSection": _vm.currentSection
    },
    on: {
      "currentUpdate": _vm.handleCurrentUpdate
    }
  })], 1), _c('GlobalFooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 256
// module chunks = 1